import React from 'react';

import Img from 'gatsby-image';
import {
  FaRss,
  FaRegAddressCard,
  FaTwitter,
  FaFacebookSquare
} from 'react-icons/fa';
import OnlyForSEO from '../OnlyForSEO';
import useAuthorPlaceholderImage from '../../graphql/staticQueries/useAuthorPlaceholderImage';

const SocialIcons = ({ author, pageUrl }) => {
  return (
    <>
      <a
        className="social-link social-link-rss"
        href={`https://feedly.com/i/subscription/feed/${pageUrl.href}rss/`}
        aria-label="Go to author's Feedly RSS page"
        target="_blank"
        rel="noopener noreferrer"
      >
        <div className="iconWrapper">
          <FaRss />
        </div>
        <OnlyForSEO text="rss link" />
      </a>
      {author.frontmatter.website && (
        <a href={author.frontmatter.website}>
          <div className="iconWrapper">
            <FaRegAddressCard />
          </div>
          <OnlyForSEO text="website link" />
        </a>
      )}
      {author.frontmatter.twitter && (
        <a href={author.frontmatter.twitter}>
          <div className="iconWrapper">
            <FaTwitter />
          </div>
          <OnlyForSEO text="twitter link" />
        </a>
      )}
      {author.frontmatter.facebook && (
        <a href={author.frontmatter.facebook}>
          <div className="iconWrapper">
            <FaFacebookSquare />
          </div>
          <OnlyForSEO text="facebook link" />
        </a>
      )}
    </>
  );
};

const AuthorHeader = ({ author, authorImage, pageUrl }) => {
  const userImg = useAuthorPlaceholderImage();
  return (
    <div className="author-header">
      <div className="container">
        <div className="content">
          <div className="left">
            <div className="image-container">
              <Img
                style={{ maxWidth: '100px', maxHeight: '100px' }}
                fixed={authorImage || userImg.fixed}
                alt={author.frontmatter.fullName}
              />
            </div>
            <div className="details">
              <h1 className="title">{author.frontmatter.fullName}</h1>
              <div className="author-meta">
                {author.frontmatter.location && (
                  <div className="author-location">
                    {author.frontmatter.location}{' '}
                    <span className="bull">&bull;</span>
                  </div>
                )}
                <div className="author-stats">
                  {(count => {
                    if (!count) return 'No posts';
                    if (count === 1) return '1 post';
                    return `${count} posts`;
                  })(author.frontmatter.relatedPostsWrittenByAuthor.length)}
                  <span className="bull bull-small">&bull;</span>
                </div>
                <div className="social-small">
                  <SocialIcons author={author} pageUrl={pageUrl} />
                </div>
              </div>
            </div>
          </div>
          <div className="social">
            <SocialIcons author={author} pageUrl={pageUrl} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthorHeader;
